import React from 'react'
import Aboutpage from '../components/Aboutpage/Aboutpage'

function About() {
  return (
    <div>
      <Aboutpage/>
      
    </div>
  )
}

export default About;
